import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=227ddcbd&scoped=true"
import script from "./Cancel.vue?vue&type=script&lang=js"
export * from "./Cancel.vue?vue&type=script&lang=js"
import style0 from "./Cancel.vue?vue&type=style&index=0&id=227ddcbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227ddcbd",
  null
  
)

export default component.exports